import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Color } from 'ng2-charts';
import 'chartjs-plugin-labels';
import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';


@Component({
  selector: 'app-brand-overview',
  templateUrl: './brand-overview.component.html',
  styleUrls: ['./brand-overview.component.scss']
})
export class BrandOverview implements OnInit {

  @Input() dataReport: any
  postCount = 0;
  shareCount = 0;
  commentCount = 0;
  likeCount = 0;
  viewCount = 0;
  interactiveCount = 0;

  numReactionsCount = 0;
  sentimentCount = 0;
  title_report = 'Thống kê nổi bật';
  public doughnutChartOptions: any = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      labels: false
    },
    legend: {
      display: false,
      labels: {
        fontSize: 12,
      }
    }
  }
  public doughnutChartOptions2: any = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      labels: false
    },
    legend: {
      display: false,
      labels: {
        fontSize: 12,
      }
    },
    circumference: Math.PI,
    rotation: -Math.PI,
    cutoutPercentage: 80
  }
  public doughnutChartType = 'doughnut';

  public doughnutChartLabels = ['Tích cực', 'Tiêu cực', 'Trung tính'];
  public doughnutChartData = [
    // [350, 450, 100]
  ];
  public doughnutChartColors: Color[] = [
    { backgroundColor: ["#00b050", "#c00000", "#bfbfbf"] }
  ];


  public doughnutChartLabels2 = ['Facebook', 'Báo chí','Youtube','Tiktok','Instagram','Linkedin'];
  public doughnutChartData2 = [
    // [500, 500]
  ];
  public doughnutChartColors2: Color[] = [
    { backgroundColor: ["#0070c0", "#ffc000","#0f6d7c","#f84e5d","#0c3f51","#4875b4","#2f7347"] }
  ];



  public barChartOptions = {
    responsive: true,
    label: false,
    maintainAspectRatio: false,
    plugins: {
      labels: {
        render: 'value',
        fontColor: 'black',
        precision: 2,
        arc: true,
        fontSize: 0,
        fontStyle: 'bold'
      }
    }
  };
  public barChartLabels = ['2006', '2007', '2008', '2009', '2010', '2011', '2012'];
  public barChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [];

  public barChartData = [
    // { data: [65, 59, 80, 81, 56, 55, 40], label: 'Series A' },
    // { data: [28, 48, 40, 19, 86, 27, 90], label: 'Series B' }
  ];
  public barChartColors: Color[] = [
    { backgroundColor: '#6998F3' },
    { backgroundColor: '#FF6262' }
  ]


  constructor() {
    console.log(this.dataReport)
  }
  getTotal(): number {
    return this.doughnutChartData2[0].reduce((a, b) => a + b, 0);
  }


  getPercentage(number: number): string {
    const total = this.getTotal();
    const percentage = (number / total) * 100;
    return percentage.toFixed(2) + '%';
  }

  getTotal2(): number {
    return this.doughnutChartData[0].reduce((a, b) => a + b, 0);
  }


  getPercentage2(number: number): string {
    if(!number) {
      return '0%';
    }
    const total = this.getTotal2();
    const percentage = (number / total) * 100;
    return percentage.toFixed(2) + '%';
  }


  ngOnInit(): void {
  };
  ngOnChanges(changes: SimpleChanges) {
    console.log(this.dataReport)
    this.mappingData()
    // changes.prop contains the old and the new value...
  }



  mappingData() {
    if(this.dataReport && this.dataReport.data && this.dataReport.data.sentiment) {
      if(this.dataReport.report_title) {
        this.title_report = this.dataReport.report_title;
      }
      this.commentCount = this.dataReport.data.commentCount;
      this.likeCount = this.dataReport.data.likeCount;
      this.shareCount = this.dataReport.data.shareCount;
      this.viewCount = this.dataReport.data.viewCount;
      this.numReactionsCount = this.dataReport.data.numReactionsCount;
      this.postCount = this.dataReport.data.postCount + this.dataReport.data.newsCount;

      this.interactiveCount =    this.dataReport.data.interactiveCount;
      this.likeCount =  this.likeCount +  this.numReactionsCount;


      this.doughnutChartData = [[this.dataReport.data.sentiment.pos || 0, this.dataReport.data.sentiment.neg || 0, this.dataReport.data.sentiment.neu || 0 ]];

      //this.sentimentCount = this.dataReport.data.sentiment.pos + this.dataReport.data.sentiment.neg + this.dataReport.data.sentiment.neu;
      this.sentimentCount =  this.postCount +this.commentCount ;

      this.doughnutChartData2 = [
        [
          this.dataReport.data.facebookCount,
          this.dataReport.data.newsCount,
          this.dataReport.data.youtubeCount,
          this.dataReport.data.tiktokCount,
          this.dataReport.data.instagramCount,
          this.dataReport.data.linkedinCount,
          this.dataReport.data.twitterCount
        ]
      ];
      this.barChartLabels = [];

      // dữ liệu bar chart
      let objComment = {
        label: 'Bình luận',
        data: []
            }
      let objPost = {
        label: 'Bài đăng',
        data: []
      }
      this.dataReport.data.byDay.forEach(day => {

        this.barChartLabels.push(day.key);
        objComment.data.push(day.comment);
        objPost.data.push(day.post)
      });
      this.barChartData = [
        objPost,
        objComment
      ];
      // end dữ liệu barcharrt
    }
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/brand-overview/brand-overview.component.ts